// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const momentSidebar = {
  moments_that_matter: {
    contentful_name: '[DEFAULT] Moments That Matter',
    moment_sidebars: [
      {
        contentful_name: '[DEFAULT] Moment Sidebar - Teladoc',
        header_mtm: '来自Teladoc的免费糖尿病支持',
        sub_header: '无限量试纸条、智能血糖仪、个性化建议和专家指导——全部由您的雇主支付。',
        button_label: '了解更多并注册',
        button_header: '您的注册码',
        topic: 'Teladoc',
        talkspace_header:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        talkspace_subheader:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        talkspace_button_label:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags.\n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      {
        contentful_name: '[DEFAULT] Moment Sidebar - Talkspace',
        header_mtm: '通过Talkspace寻找在线治疗师',
        sub_header:
          '回答几个问题,即可立即匹配符合您心理健康需求的持证服务提供者。Talkspace灵活便捷、完全加密且免费!',
        button_label: '前往 Talkspace',
        button_header:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        topic: 'talkspace',
        talkspace_header:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        talkspace_subheader:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        talkspace_button_label:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
    ],
  },
};
